const ActionType = {
  SET_PAGE_NMO: 'SET_PAGE_NMO',
  SET_SOURCE: 'SET_SOURCE',
}

export default ActionType
